export default "__VITE_ASSET__c8332445__"